/* eslint-disable no-param-reassign */
import React, { useEffect, Fragment, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bool, func, arrayOf, shape } from "prop-types";
import * as i18n from "util/i18n";
import { push } from "connected-react-router";
import classNames from "classnames";
import { actions as afipPaymentLinkActions, selectors as afipPaymentLinkSelectors } from "reducers/afipPaymentLink";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as notificationActions } from "reducers/notification";
import ProductSelector from "pages/discounts/DiscountCreation/components/ProductSelector";
import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import Options from "pages/accounts/_components/Options";
import AccountAction from "pages/accounts/_components/AccountAction";
import { actions as menuActions } from "reducers/drawer";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomProductHead from "pages/_components/CustomProductHead";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import Button from "pages/_components/Button";
import Image from "pages/_components/Image";
import { isIOS } from "react-device-detect";
import PaymentDueList from "../components/PaymentDueList";

const PaymentSchedule = (props) => {
    const { isDesktop, fetching, dispatch, paymentSchedule, accounts } = props;
    const [itemsToDisplay, setItemsToDisplay] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [availableAccounts, setAvailableAccounts] = useState([{ id: "1" }]);
    const [selectedAccount, setSelectedAccount] = useState(null);

    useEffect(() => {
        dispatch(afipPaymentLinkActions.getPaymentSchedule({ isArcaPayment: true }));
        dispatch(accountsActions.listAccounts());
    }, []);

    useEffect(() => {
        if (paymentSchedule && paymentSchedule.length > 0) {
            const aux = [];
            paymentSchedule.forEach((element) => {
                const { paymentDueList, codeLink, entityId } = element;
                if (paymentDueList && paymentDueList.length > 0) {
                    const list = paymentDueList;
                    list.forEach((item) => {
                        item.codeLink = codeLink;
                        item.entityId = entityId;
                        // ARBIBIMPLE-11056: Se genera campo id on the fly ya que el debtId se puede repetir
                        //  entre servicios para diferentes CUIT/CUIL
                        item.id = `${item.codeLink}-${item.debtId}`;
                    });
                    aux.push(...list);
                }
            });
            setItemsToDisplay(aux);
        }
    }, [paymentSchedule]);

    useEffect(() => {
        if (accounts?.length) {
            const formatOption = (account) => ({
                balance: { currency: account?.currency, quantity: account?.availableBalance },
                currency: account?.currency,
                frequentDestination: null,
                id: account?.productId,
                label: `${i18n.get(`productType.${account?.accountType}`)} ····${account?.accountNumber?.slice(-4)}`,
                minimumPayment: 0,
                permissions: Object.keys(account?.permissions),
                statementsLoan: null,
                totalPayment: 0,
                type: account?.accountType,
                accountNumber: account?.accountNumber,
            });

            setAvailableAccounts(accounts.filter((acc) => acc.currency === "ARS")?.map((acc) => formatOption(acc)));
        }
    }, [accounts]);

    const handleChangeSelectedItems = (selectedItems, totalAmountSelected) => {
        if (selectedItems.length === 0) {
            setSelectedAccount(null);
        }
        setSelectedServices(selectedItems);
        setTotalAmount(totalAmountSelected);
    };

    const validAmount = (accountId) => {
        const selected = availableAccounts.find((_account) => _account.id === accountId);
        return totalAmount <= selected?.balance?.quantity;
    };

    const selectAccount = (accountId) => {
        setSelectedAccount(accountId);
        if (!validAmount(accountId)) {
            dispatch(
                notificationActions.showNotification(i18n.get("insuficient.amount.error"), "error", ["afipServices"]),
            );
        }
    };

    const continueIsNotAllowed = () => {
        const paymentIsNotAllowed =
            (itemsToDisplay.length > 0 && selectedServices.length === 0) ||
            (selectedServices.length > 0 && (!selectedAccount || !validAmount(selectedAccount)));

        return paymentIsNotAllowed;
    };

    const handleContinue = () => {
        const account = availableAccounts.filter((a) => a.id === selectedAccount)[0];
        const servicesPaymentData = { selectedServices, totalAmount, account, cuit: null };
        dispatch(afipPaymentLinkActions.setServicesPaymentData(servicesPaymentData));
        dispatch(push("/arcaServices/newPayment/confirm"));
    };

    const handleClick = () => {
        dispatch(menuActions.menuShow());
    };

    const renderHeader = () => {
        const renderMenuOption = () => (
            <>
                {isDesktop ? (
                    <>
                        <div className="toolbar-item add-button" key="add">
                            <Link className="btn btn-primary btn-block" to="/arcaServices/newPayment">
                                <Image src="images/figma/icon/nuevo.svg" className="icon-medium svg-icon" />
                                <I18n
                                    id="afip.services.new.payment"
                                    componentProps={!isDesktop && { className: "visually-hidden" }}
                                />
                            </Link>
                        </div>
                    </>
                ) : (
                    <div className="toolbar-item commands-mobile">
                        <Button
                            className="toolbar-btn view-options"
                            onClick={handleClick}
                            image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}
                            label="view more options"
                            block={false}
                            bsStyle="link"
                        />
                    </div>
                )}
            </>
        );
        return (
            <>
                <CustomProductHead
                    titleId="afip.services.title"
                    backLinkTo="/vepPayments"
                    className="accounts"
                    renderMenuOption={renderMenuOption}>
                    <div className="toolbar-item view-title">
                        <ViewTitle id="afip.services.title" />
                    </div>
                </CustomProductHead>
            </>
        );
    };

    return (
        <Fragment>
            <Notification scopeToShow="afipServices" />
            {!fetching && renderHeader()}
            <MainContainer showLoader={fetching}>
                <div className="container">
                    <CustomText
                        text={i18n.get("afip.services.payment.schedule.title", "Servicios agendados")}
                        textType="TEXT"
                        className="discounts-echeq-review__date-control"
                    />
                    <div className="pb-6" />
                    {itemsToDisplay && itemsToDisplay.length > 0 ? (
                        <Fragment>
                            <PaymentDueList
                                dataToList={itemsToDisplay}
                                {...props}
                                onChange={(selectedItems, totalAmountSelected) =>
                                    handleChangeSelectedItems(selectedItems, totalAmountSelected)
                                }
                            />

                            {!!selectedServices.length && (
                                <>
                                    <GridTable className="summary-selected-items-table mt-6">
                                        <GridTable.Container columns={3} rows={2}>
                                            <GridTable.Data columnStart={1} rowStart={1} rowWidth={isDesktop ? 2 : 1}>
                                                <div className="discount-bubble-wrapper">
                                                    <Image
                                                        src={
                                                            isIOS
                                                                ? "images/figma/icon/success-primary.svg"
                                                                : "images/figma/icon/success.svg"
                                                        }
                                                        className={classNames("svg-icon")}
                                                    />
                                                    <CustomText
                                                        text={
                                                            selectedServices.length > 1
                                                                ? `${selectedServices.length} pagos seleccionados`
                                                                : `${selectedServices.length} pago seleccionado`
                                                        }
                                                    />
                                                </div>
                                            </GridTable.Data>
                                            {!isDesktop && (
                                                <GridTable.Data
                                                    className={isIOS ? "line-dashed-wrapper" : null}
                                                    columnStart={1}
                                                    rowStart={2}
                                                    columnWidth={2}>
                                                    <div className="line-dashed" />
                                                </GridTable.Data>
                                            )}
                                            <GridTable.Data
                                                alignX="end"
                                                columnStart={2}
                                                rowStart={isDesktop ? 1 : 3}
                                                columnWidth={1}>
                                                <CustomText
                                                    className="services.payment.total.amount"
                                                    text="Monto total"
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data
                                                alignX="end"
                                                columnStart={2}
                                                rowStart={isDesktop ? 2 : 4}
                                                columnWidth={1}>
                                                <FormattedAmount quantity={totalAmount} currency="ARS" />
                                            </GridTable.Data>
                                        </GridTable.Container>
                                    </GridTable>
                                </>
                            )}
                            {selectedServices && selectedServices.length > 0 && (
                                <div className="grid-table box box-shadow mt-6">
                                    <div className="grid-table-row sm:flex md:grid-cols-12">
                                        <div className="grid-table-data md:col-start-2 md:col-span-10">
                                            <ProductSelector
                                                name="debitAccount"
                                                idField="discount-acreditation-account"
                                                label={i18n.get("vep.payment.data.debit.account", "Cuenta débito")}
                                                placeholder={i18n.get(
                                                    "deposits.request.filters.debitAccount.placeHolder",
                                                    "Seleccioná una cuenta",
                                                )}
                                                data={{ options: availableAccounts || [] }}
                                                onChange={(value) => selectAccount(value)}
                                                value={selectedAccount}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="grid-table form-actions">
                                <div className="grid-table-row sm:flex md:grid-cols-12">
                                    <div className="grid-table-data md:col-start-5 md:col-span-4">
                                        <Button
                                            bsStyle="primary"
                                            label="global.continue"
                                            loading={fetching}
                                            block
                                            onClick={() => handleContinue()}
                                            disabled={continueIsNotAllowed()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    ) : (
                        <div className="box info">
                            <CustomData
                                icon="information_fill.svg"
                                titleText="afip.services.payment.schedule.empty"
                                titleTextType="I18N"
                            />
                        </div>
                    )}
                    <div className="pb-6" />
                </div>
            </MainContainer>
            {!isDesktop && (
                <Options>
                    <AccountAction
                        isDesktop={isDesktop}
                        labelKey="afip.services.new.payment"
                        to="/arcaServices/newPayment"
                    />
                </Options>
            )}
        </Fragment>
    );
};

PaymentSchedule.propTypes = {
    isDesktop: bool,
    isFetchingExport: bool,
    dispatch: func.isRequired,
    isMobile: bool,
    fetching: bool,
    paymentSchedule: arrayOf({}).isRequired,
    accounts: arrayOf(shape({})).isRequired,
};

PaymentSchedule.defaultProps = {
    isFetchingExport: false,
    isDesktop: true,
    isMobile: false,
    fetching: false,
};

const mapStateToProps = (state) => ({
    fetching: afipPaymentLinkSelectors.getFetching(state),
    paymentSchedule: afipPaymentLinkSelectors.getPaymentSchedule(state),
    accounts: accountsSelectors.getAccounts(state),
});

export default connect(mapStateToProps)(PaymentSchedule);
